import fetch from '@/fetch'
// 排行榜数据获取
export const rankingGet = (params) => {
  return fetch({
    method: 'post',
    url: '/common/h5/largescreen/gettoplist',
    data: params,
    actionTypeCode: '38',
    actionTypeDesc: '排行榜数据获取',
    loading: true,
  })
}
